import {
  ISimpleTableCellRenderProps,
  ISimpleTableField,
  ISimpleTableRow,
  ISimpleTableSort,
} from "./interface";
import { SimpleTable } from "./SimpleTable";

export { SimpleTable };
export type { ISimpleTableCellRenderProps, ISimpleTableField, ISimpleTableRow, ISimpleTableSort };
